import { render, staticRenderFns } from "./TravelRouter.vue?vue&type=template&id=11b5383a"
import script from "./TravelRouter.vue?vue&type=script&lang=js"
export * from "./TravelRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports